import {Field, connect} from 'formik'
import {FormRadio} from './'

export const RecurringSelection = connect(({formik}) => {
  if (!formik.values._show_recurring) return null

  const isRecurringPaymentMethod = ['stripe_sepa_debit', 'paypal', 'stripe_cc'].includes(formik.values.payment_method)

  return <div className='form-group flex mb-0'>
    <Field
      name='interval'
      component={FormRadio}
      className='py-3 cursor-pointer'
      value='single'
      label={I18n.t(`donate.recurring_interval.single`)}
    />

    <Field
      name='interval'
      component={FormRadio}
      className='px-3 py-3 cursor-pointer'
      value='monthly'
      label={I18n.t(`donate.recurring_interval.monthly`)}
      disabled={!isRecurringPaymentMethod}
    />

    <Field
      name='interval'
      component={FormRadio}
      className='pl-1 py-3 cursor-pointer'
      value='yearly'
      label={I18n.t(`donate.recurring_interval.yearly`)}
      disabled={!isRecurringPaymentMethod}
    />
  </div>
})
